import JsBarcode from 'jsbarcode';
import React from 'react';
import { Image } from "@react-pdf/renderer";

const GenerateBarCodeImage = (barCodeValue: string, barCodeHeight: number, barCodeWidth: number, barCodeFontSize: number) => {
  const canvas = document.createElement('canvas');
  JsBarcode(canvas, barCodeValue, {
    height: barCodeHeight,
    width: barCodeWidth,
    fontSize: barCodeFontSize
  });
  return canvas.toDataURL('image/png'); 
};

interface GenerateBarCodeImageProps {
  barCodeValue: string;
  barCodeHeight: number;
  barCodeWidth: number; 
  barCodeFontSize: number;
}

export const PdfBarCodeGenerator: React.FC<GenerateBarCodeImageProps> = ({
  barCodeValue,
  barCodeHeight,
  barCodeWidth,
  barCodeFontSize
}) => {
  const barCodeImage = GenerateBarCodeImage(barCodeValue, barCodeHeight, barCodeWidth, barCodeFontSize);

  return <Image src={barCodeImage} />;
};